// extracted by mini-css-extract-plugin
export default {"root":"FormMessage-module-root","valid":"FormMessage-module-valid","invalid":"FormMessage-module-invalid","tip":"FormMessage-module-tip","isInLogin":"FormMessage-module-isInLogin"};